export default "__VITE_ASSET__ChhGvQSW__"